import React from 'react';
import { msToTime, isZero, isUnlimited } from '../../../../lib/date.utils';
import { sanitizeHtml } from '../../../../lib/html.utils';

const DEFAULT_BORDER_COLOR = '#dedede';

const isHiddenLabel = label => label.toLowerCase() === 'hidden';

const DetailsClearance = ({ clearing = {} }) => {
    const items = Object.entries(clearing).filter(
        ([key, value]) => value?.category?.label && !isHiddenLabel(value.label?.label)
    );

    if (!items.length) return null;

    return (
        <React.Fragment>
            <p className="ckp-entry-details-label">Clearance Status</p>
            <div className="ckp-entry-details-field">
                {items.map(([categoryId, entry]) => {
                    const categoryLabel = entry?.category?.label || '';
                    const optionLabel = entry.label?.label || '';
                    const optionColor = entry.label?.color || DEFAULT_BORDER_COLOR;
                    const untilDate = entry.untilDate;
                    const untilText =
                        untilDate && !isZero(untilDate) && !isUnlimited(untilDate)
                            ? ` - Until: ${msToTime(untilDate)}`
                            : '';

                    return (
                        <p
                            key={categoryId}
                            className="ckp-entry-details-status"
                            style={{ borderLeft: `solid 5px ${optionColor}` }}
                        >
                            <span className="u-inline-block">
                                {categoryLabel}:{' '}
                                <span className="u-uppercase">
                                    {optionLabel ? String(optionLabel).replace(/_/g, ' ') : '—'}
                                </span>
                            </span>
                            <span style={{ marginLeft: '5px' }} className="u-inline-block">
                                {untilText}
                            </span>
                        </p>
                    );
                })}
            </div>
            {clearing.comment ? (
                <div className="ckp-entry-details-comments is-live">
                    <p className="ckp-entry-details-label">Comments</p>
                    <div className="ckp-entry-details-field">
                        {(clearing.comment || 'No comments').split(/\n/).map((x, i) => (
                            <p key={i} dangerouslySetInnerHTML={{ __html: sanitizeHtml(x) || '&nbsp;' }} />
                        ))}
                    </div>
                </div>
            ) : null}
        </React.Fragment>
    );
};

export default DetailsClearance;
